module.exports = __webpack_public_path__ + "assets/img/title.b283df7e.png";